(function () {
  'use strict';

  if (customElements.get('mr-beard-recommendation-selector')) return;

  class RecommendationSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.tabs = Array.from(this.querySelectorAll('[data-recommendation-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-recommendation-panel]'));
      this.liveRegion = this.querySelector('[aria-live]');
      if (!this.tabs.length || !this.panels.length) return;

      this.dataset.initialized = 'true';
      this.dataset.enhanced = 'true';
      this.classList.add('is-ready');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-recommendation-panel]');
        if (!panel) return;

        const index = this.panels.indexOf(panel);
        if (index >= 0) this.select(index, false);
      });
      const selected = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.select(selected < 0 ? 0 : selected, false);
    }

    select(index, announce = true) {
      const next = Math.max(0, Math.min(index, this.tabs.length - 1));
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === next;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-active', active);
      });
      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== next;
      });
      if (announce && this.liveRegion) {
        this.liveRegion.textContent = this.tabs[next].dataset.announcement || this.tabs[next].textContent.trim();
      }
    }

    onKeydown(event, index) {
      let next = index;
      const isRtl = getComputedStyle(this).direction === 'rtl';
      if (event.key === 'ArrowRight') next = (index + (isRtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + (isRtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
      else if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
      else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      else return;

      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }
  }

  customElements.define('mr-beard-recommendation-selector', RecommendationSelector);
})();
